import { useMemo } from 'react'
import { WidgetId } from 'features/types'

import { useAppSelector } from '../app/hooks'
import { WidgetTypeStrings } from '../enums/WidgetType'
import { DashboardWidget, DashboardWidgetData } from '../features/widget/types'
import { EntryData } from '../schemas/ServiceResultSchema'

// widget display data for dashboard
export const useDashboardWidgetData = <T extends EntryData | unknown = unknown>(
  widgetId: WidgetId
): DashboardWidget<T> => {
  const widgetData = useAppSelector(({ widget }) => widget.dashboardWidgets[widgetId])
  return widgetData
}

export const useDashboardWidgetPreWork = <T extends EntryData | unknown = unknown>(
  widgetId: WidgetId
): DashboardWidgetData<T>[] => {
  const widgetData = useAppSelector(({ widget }) => widget.dashboardWidgets[widgetId])
  return widgetData.preWorkData
}

// widget display data for analyze
export const useAnalyzeWidgetData = <T = any>(widgetType: WidgetTypeStrings): T => {
  const widgetData = useAppSelector(({ widget }) => widget.analyzeWidget[widgetType])
  return widgetData
}

export const useAllWidgetsReady = (): boolean => {
  const allWidgetReady = useAppSelector(({ widget }) =>
    Object.values(widget.dashboardWidgets).every(
      (w) =>
        w.status !== 'loading' && w.preWorkStatus !== 'loading' && w.loadMoreStatus !== 'loading'
    )
  )
  return allWidgetReady
}

export const useIsWidgetLoading = (widgetId: WidgetId) => {
  const widgetData = useDashboardWidgetData(widgetId)

  const isLoading = useMemo(
    () =>
      !widgetData ||
      widgetData.status === 'loading' ||
      widgetData.preWorkStatus === 'loading' ||
      widgetData.loadMoreStatus === 'loading',
    [widgetData]
  )

  return isLoading
}
